import { render, staticRenderFns } from "./ArticleCardStyleme.vue?vue&type=template&id=55d1057a&"
import script from "./ArticleCardStyleme.vue?vue&type=script&lang=js&"
export * from "./ArticleCardStyleme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports